import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_ccy_RowClass} from '../../../dbschema/bl_fi_mst_ccy.model';

export class CurrencyContainerModel extends BaseContainerModel {
  bl_fi_mst_ccy: bl_fi_mst_ccy_RowClass = new bl_fi_mst_ccy_RowClass();
}
